import styled from 'styled-components';

export const StyledVictimItem = styled.div`
  background-color: #fff;
  box-shadow: 0px 1px 3px #000000;
  border-radius: 4px;
  height: fit-content;
  color: #2b2727;
  font-size: 13px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  padding: 10px 16px;
  max-width: 200px;
  margin-right: 16px;
`;
